import type { IconSvgObject } from './types';

const CornerUpLeftIcon: IconSvgObject = [
  ["path", { d: "M4 9.00195H11C14.7712 9.00195 16.6569 9.00195 17.8284 10.1735C19 11.3451 19 13.2307 19 17.002V20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99996 4.00195C7.99996 4.00195 3.00001 7.6844 3 9.00199C2.99999 10.3196 8 14.002 8 14.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerUpLeftIcon;
